<div class="confirm-dialog-wrapper">
    <h1 id="confirmation-header">
        Login to SchoolDay
    </h1>

    <div class="title notification p-0">
        <span>{{message}}<span class="notification-action-link font-weight-500" (click)="redirectToSchoolPassport()">click here</span>.</span>
    </div>

    <div class="button-row">
        <button mat-raised-button color="primary" class="confirm-btn" (click)="onClose()">Ok</button>
    </div>

</div>
